






































import { Vue, Component, Prop } from "vue-property-decorator";
import * as data from "../../_store/data.module";
import TirociniEstiviDoc from "../ActivitiesDoc/TirociniEstiviDoc.vue";
import TirociniFormativiDoc from "../ActivitiesDoc/TirociniFormativiDoc.vue";
import AlternanzaDoc from "../ActivitiesDoc/AlternanzaDoc.vue";
import TirociniReInsDoc from "../ActivitiesDoc/TirociniReInsDoc.vue";
import { bus } from "../../main";

@Component({
  components: {
    TirociniEstiviDoc,
    TirociniFormativiDoc,
    AlternanzaDoc,
    TirociniReInsDoc
  }
})
export default class ActivitiesDocDialog extends Vue {
  @Prop() idRichiesta!: number;
  @Prop() activityType!: string;
  @Prop() soggetto!: string; //entità che visualizza l'elenco documenti
  @Prop() statoAttivita!: number;
  @Prop() tipoQuestionario!: string;
  @Prop() info!: any;
  private dialog: boolean;

  constructor() {
    super();
    this.dialog = false;
  }

  close() {
    this.dialog = false;
    bus.$emit("destroyDocDialog");
  }

  created() {
    bus.$on("closeActivityDialog", () => {
      this.close();
    });
  }
}
